import {clientVisitService} from 'services/clientVisitService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {ClientVisit} from 'types/clientVisit';

const clientVisitFactory = (data: any) => new ClientVisit(data);

export const ClientVisitThunks = createEntityThunks<ClientVisit>(
  'clientVisit',
  clientVisitService,
  {activate: true, deactivate: true},
  clientVisitFactory,
);

